<template>
    <b-row>
        <div class="col-sm-12 mt-3">
            <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                <thead>
                    <tr>
                        <th style="width: 45%;text-align: center;">
                            Nombre
                        </th>
                        <th style="width: 35%;text-align: center;">
                            Usuario
                        </th>
                        <th style="width: 20%;text-align: center;">
                            ...
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in vendedores" :key="index">
                        <td style="text-align: center;">
                            {{ item.nombre_completo }}
                        </td>
                        <td style="text-align: center;">
                            {{ item.username }}
                        </td>
                        <td style="text-align: center;">
                            <button type="button" style="font-size: 10px;margin-right: 10px;"
                                class="btn btn-sm btn-outline-dark"
                                v-if="permisos['sucursales.usuarios']?.actualizar || ES_ROOT"
                                @click="abrir_edicion(item)">
                                <i class="fas fa-eye"></i>
                            </button>
                            <button type="button" style="font-size: 10px;margin-right: 10px;"
                                class="btn btn-sm btn-outline-dark" v-else disabled>
                                <i class="fas fa-eye"></i>
                            </button>

                            <button type="button" style="font-size: 10px;" class="btn btn-sm btn-outline-dark"
                                v-if="permisos['sucursales.usuarios']?.borrar || ES_ROOT"
                                @click="eliminar_usuario(item.id)">
                                <i class="fas fa-trash"></i>
                            </button>
                            <button type="button" style="font-size: 10px;" class="btn btn-sm btn-outline-dark" v-else
                                disabled>
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-row>
</template>

<script>
    import { pregunta } from '@/components/functions/alertas';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'ListaUsuarios',
        computed: {
            ...mapState(['usuarios', 'vendedores', 'permisos', 'datos_usuario']),
            ...mapGetters(['ES_ROOT'])
        },
        data() {
            return {

            }
        },
        methods: {
            async eliminar_usuario(id) {
                pregunta({ titulo: 'Seguro que deseas borrar el registro?', texto: 'Estaacción no se puede revertir', afirmacion: 'Si, borrar!' }, async (i) => {
                    if (i) {
                        let f = {
                            api: `users/${id}`
                        }

                        await this.borrar_data(f)
                        // await this.obtener_usuarios()
                        await this.obtener_vendedores()

                    }
                })
            },
            abrir_edicion(item) {
                this.set_usuario_a_editar(item)
                this.$emit('set_abrir_edicion')
            },
            ...mapActions(['obtener_usuarios', 'borrar_data', 'obtener_vendedores']),
            ...mapMutations(['set_usuario_a_editar'])
        },
        mounted() {
            // this.obtener_usuarios()
            this.obtener_vendedores()
        },
    }
</script>

<style></style>